// extracted by mini-css-extract-plugin
module.exports = {"section":"App_section__1OL6S"};